import { useInputTypes } from "../hooks/useInputTypes";
import { CreateInputTypeDialog } from "../components/inputTypes/CreateInputTypesDialog";
import { InputTypesTable } from "../components/inputTypes/InputTypesTable";
import { LoadingAnimation } from "@/shared/components/LoadingAnimation";

export const InputTypeManagement = () => {
  const { data: inputTypes, isLoading, error } = useInputTypes();

  if (isLoading) {
    return <LoadingAnimation fullScreen />;
  }

  if (error) {
    return (
      <div className="rounded-lg border border-red-200 bg-red-50 p-4">
        <p className="text-red-600">Failed to load input types</p>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Input Types</h1>
          <p className="text-gray-500 mt-1">
            Manage input types in the system
          </p>
        </div>
        <CreateInputTypeDialog />
      </div>

      <InputTypesTable inputTypes={inputTypes || []} />
    </div>
  );
};